import { FC } from 'react';
import { EightySixthError } from 'components/EightySixthError';
import { ScanToOrderError } from './ScanToOrderError';

type ErrorBannerProps = {
  onClick?: () => void;
};

export const ErrorBanner: FC<ErrorBannerProps> = ({ onClick }) => {
  return (
    <>
      <EightySixthError />
      <ScanToOrderError />
    </>
  );
};
